<template>
    <el-container v-wechat-title="title" :style="{ height: this.screenHeight + 'px' }">
        <el-main>
            <div class="sign_div">
                <el-form>
                    <el-form-item>
                        <el-input v-model="rawData" type="textarea" :autosize="{ minRows: 2 }" :clearable="true" :autofocus="true"> </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" style="width: 100%" @click="sign()" size="medium">签名</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-main>

        <el-dialog :title="title" :close-on-click-modal="false" width="30%" :destroy-on-close="true" :visible.sync="dialogVisible" v-if="dialogVisible">
            <div style="height: 400px">
                <iframe ref="signPage" :src="signUrl" class="docframe width-p100" seamless style="height: 380px"></iframe>
            </div>
        </el-dialog>
    </el-container>
</template>

<script>
export default {
    name: `SignTest`,
    data() {
        return {
            title: `签名测试`,
            screenHeight: document.documentElement.clientHeight,
            rawData: ``,
            caSignUrl: this.$root.CaSignUrl,
            signUrl: ``,
            dialogVisible: false
        }
    },
    mounted() {
        window.addEventListener(`message`, this.dealFrameMessage)
    },
    methods: {
        dealFrameMessage(e) {
            if (!e.data.msg) return
            if (e.data.action == `ok`) {
                this.$notify.success({
                    title: `提示`,
                    message: `${e.data.msg}`
                })
                this.dialogVisible = false
                this.signUrl = ``
            } else if (e.data.action == `closeWindow`) {
                this.dialogVisible = false
            } else {
                this.$notify.error({
                    title: `错误`,
                    message: `${e.data.msg}`
                })
            }
        },
        sign() {
            let url = `${this.caSignUrl}?app_key=${this.$root.appKey}&ca_token=`
            let caToken = this.$route.query.ca_token
            if (caToken) url = `${url}${caToken}`
            this.myaxios.post(url, {
                user_agent: `chrome`,
                timestamp: new Date().getTime(),
                data: {
                    biz_id: `TEST`,
                    raw_data: this.rawData
                }
            }).then((signUrl) => {
                this.signUrl = signUrl
                this.dialogVisible = this.signUrl != ``
            })
        }
    }
}
</script>

<style scoped>
.sign_div {
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/SignTest.vue